import React, { Component } from 'react';
import { Text, View, FlatList } from 'react-native';
import NetInfo from '@react-native-community/netinfo';
import { DeviceInfo,QSendNotification, } from 'qunar-react-native';
import { reaction, toJS } from 'mobx';
import { inject, observer } from 'mobx-react/native';
import { getComponentByBusinessType, headerTitleByBusinessType } from './businessComps/index';
import LoadControl from '../LoadControl';
import ItemWrapper from './ItemWrapper';
import BackToTop from './BackToTop';
import NoData from './NoData';
import Spin from '../Spin';
import styles from './style';
import Alert from '../Alert';
import Confirm from '../Confirm';
import OrderWxPopup from '../OrderWxPopup';
import uitls from './businessComps/utils';
import * as loginUtil from '../../Utils/loginUtil';
import { RootStoreInterface } from '../../Store/index';
import OrderList from './store';
import QImageSet from '../../assets/QImageSet';
import { qav } from '../../Utils/qav';
// import { PerQavManager } from '../../Utils/PerQavManager';
import PerfQav from '../../Utils/perfQav';
import PPLogUtil, { OPER_SHOW } from '../../Utils/PPLogUtil';
import LoginManager from '../../Utils/LoginManager'
import MoreButtonList from "../MoreButtonList/index";
import DebugButton from '../DebugButton';
import GuideWeChat from '../../Views/GuideWeChat';
import { Slugger } from '@qnpm/q-pkgs-slugger';
import QSlugger from '../Slugger/qSlugger';
// 刷新控件的高度
const REFRESH_HEIGHT_ADR = 38;
// const REFRESH_HEIGHT_IOS = 50;
const { isMini } = DeviceInfo;

const INITIAL_LOAD_NUM = 3;// 初始状态下，加载几条订单

interface Props {
    pageName?: string;
    inLoading?: boolean;
    hasMore?: boolean;
    needScrollTopAndRefresh?: boolean;
    loadmoreSuc?: boolean;
    originDataSource?: any[];
    dataSource?: any[];
    enableDelete?: boolean;
    alertVisible?: boolean;
    alertTitle?: string;
    cofirmVisible?: boolean;
    privateVisible?:boolean;
    useCache?: boolean;
    showLoadMore?: boolean;
    needPerfQavLog?: boolean;

    orderlist?: OrderList;

    statusFilter?: string;

    sourceFrom?:string;
    perfQav?:PerfQav;
    loginManager?:LoginManager,

    init?(type?: string): void;
    loadMore?(): void;
    privateCofirmVisible?(cofirmVisible: boolean): void;
    privateCofirmCallback?(): void;
    onOrderDeletePress?(deleteInfo: { canDelete: boolean; deleteTip: string }): void;
    onAlertClose?(): void;
    onDeleteConfirmOk?(): void;
    onDeleteConfirmCancel?(): void;
    onOrderItemPress?(): void;
    onOrderBtnPress?(): void;
    onloginSuc?(params: any): void;
    toggleNetworkConnect?(isNetworkConnect: boolean): void;
    toggleShowBackToTop?(showBackToTop: any): void;
    setInLoading?(inLoading: number): void;
    clearRedPoint?(sysCode: number, orderNo: string): void;
    orderSearchFlag?(): void;
    orderPopup?:any;
    orderPopupVisible?:boolean;
    onCancelWxPopup?(flag: boolean): void;
}
interface State {
    refreshing: boolean,
    loading: boolean,
    showBackToTop:boolean
}

@inject((store: RootStoreInterface) => ({
    // 属性
    pageName: store.orderlist.pageName,
    // 加载中开关
    inLoading: store.orderlist.inLoading,
    // 还有下一页数据
    hasMore: store.orderlist.hasMore,
    // 需要滚动到顶部再刷新
    needScrollTopAndRefresh: store.orderlist.needScrollTopAndRefresh,
    // 加载更多是否成功
    loadmoreSuc: store.orderlist.loadmoreSuc,
    // 数据源
    originDataSource: store.orderlist.originDataSource,
    dataSource: store.orderlist.dataSource,
    // 开启删除功能，即ios左滑，安卓长按
    enableDelete: store.orderlist.enableDelete,
    // alert 弹窗是否可见
    alertVisible: store.orderlist.alertVisible,
    // alert 弹窗标题
    alertTitle: store.orderlist.alertTitle,
    // confirm 弹窗是否可见
    cofirmVisible: store.orderlist.cofirmVisible,
    //无痕订单-点击客服提示
    privateVisible:store.orderlist.privateVisible,
    // 是否开启缓存功能
    useCache: store.orderlist.useCache,
    // 是否展示加载更多
    showLoadMore: store.orderlist.showLoadMore,
    // 需要发送qav性能埋点
    needPerfQavLog: store.orderlist.needPerfQavLog,
    // 页面来源
    sourceFrom:store.uiState.sourceFrom,
    // 登录管理类
    loginManager:store.loginManager,
    // 异步按钮
    serviceBtnList: store.orderlist.serviceBtnList,

    // 方法
    // 初始化数据
    init: store.orderlist.init,
    // 上拉加载
    loadMore: store.orderlist.loadMore,

    //滚动到列表顶部
    scrollToTop: store.orderlist.scrollToTop,
    privateCofirmVisible: store.orderlist.privateCofirmVisible,
    privateCofirmCallback: store.orderlist.privateCofirmCallback,
    // 点击删除按钮或者安卓长按订单
    onOrderDeletePress: store.orderlist.onOrderDeletePress,
    // 点击不能删除订单 alert 弹窗的关闭按钮
    onAlertClose: store.orderlist.onAlertClose,
    // 点击确认删除订单 confirm 弹窗的确认按钮
    onDeleteConfirmOk: store.orderlist.onDeleteConfirmOk,
    // 点击确认删除订单 confirm 弹窗的取消按钮
    onDeleteConfirmCancel: store.orderlist.onDeleteConfirmCancel,
    // 点击订单
    onOrderItemPress: store.orderlist.onOrderItemPress,
    // 点击订单按钮
    onOrderBtnPress: store.orderlist.onOrderBtnPress,
    // 点击登录成功后
    onloginSuc: store.orderlist.onloginSuc,
    // 切换网络连接状态
    toggleNetworkConnect: store.orderlist.toggleNetworkConnect,
    // 切换回到顶部按钮显隐
    toggleShowBackToTop: store.orderlist.toggleShowBackToTop,
    // 切换 loading 显隐
    setInLoading: store.orderlist.setInLoading,
    // 清除订单红点
    clearRedPoint: store.orderlist.clearRedPoint,
    // 响应式和命令式编程的桥梁
    orderlist: store.orderlist,
    // 当前的tab
    statusFilter: store.uiState.statusFilter,
    perfQav:store.perfQav,
    orderSearchFlag: store.orderlist.orderSearchFlag,
    orderPopup: store.guideWeChat.orderPopup,
    orderPopupVisible: store.guideWeChat.orderPopupVisible,
    onCancelWxPopup:store.guideWeChat.onCancelWxPopup
}))
@observer
class OrderListComp extends Component<Props,State> {
    public loadLock = false;

    public timer: any = null;

    public scrollViewRef: any = null;

    // curScrollViewState = 'normal';

    public scrollY = 0;

    public openedSwipe: any = null;

    public closeSwipe: () => any = null;

    // reaction 的 dispose
    public stopInLoadingDispose: () => void;

    public inLoadingTimer: any;

    public stopLoadMoreDispose: () => void;

    public stopRefreshDispose: () => void;

    public scrollTopAndRefreshDispose: () => void;

    public datasourceDispose: () => void;

    public asyncBtnListDispose: () => void;

    // 本次更新是否是 init 那次
    public updateIsInit = false;

    public refreshControl: any;
    public viewabilityConfig: { waitForInteraction: boolean; itemVisiblePercentThreshold: number };

    public netInfoLintener: () => void | undefined;
    private viewableItems: any[];

    public constructor(props: Props) {
        super(props);
        this.state = {
            refreshing: false,
            loading: false,
            showBackToTop:false
        }
        // 停止加载更多
        this.stopInLoadingDispose = reaction(
            () => props.orderlist.inLoading,
            (loading: boolean) => {
                if (loading) {
                    this.inLoadingTimer = setTimeout(() => {
                        const { orderlist } = props;
                        orderlist.inLoading = 0;
                        if (orderlist.originDataSource.length === 0) {
                            orderlist.showNoDataView({
                                isLogin: true,
                                type: "dataLoadFail"
                            });
                        }
                    }, 10000);
                } else {
                    clearTimeout(this.inLoadingTimer);
                }
            }
        );

        // 停止加载更多
        this.stopLoadMoreDispose = reaction(
            () => props.orderlist.needStopLoadMore,
            () => {
                this.setState({
                    loading: false
                });
            }
        );
        // 停止下拉刷新
        this.stopRefreshDispose = reaction(
            () => props.orderlist.needStopRefresh,
            () => {
                // this.scrollToTop(true);
                this.setState({
                    refreshing: false
                });
            }
        );

        // // 开始loading刷新列表
        // this.startRefreshWithLoadingDispose = reaction(
        //     ()=> props.orderlist.needStartRefreshWithLoading,
        //     () =>{
        //         this.scrollViewRef.scrollToTop()
        //         this.onRefresh()
        //     }
        // )


        this.scrollTopAndRefreshDispose = reaction(
            () => props.orderlist.needScrollTopAndRefresh,
            () => {
                // this.scrollToTop(false);
                props.init();
            }
        );

        this.datasourceDispose = reaction(
            () => props.orderlist.dataSource,
            () => {
                // 一旦数据源变了，那没swipe组件就会更新 或者卸载重新创建，老的 openedSwipe 和 closeSwipe 就有可能过时
                this.closeSwipe && this.closeSwipe();
                this.openedSwipe = null;
                this.closeSwipe = null;
            }
        );

        this.asyncBtnListDispose = reaction(
            () => props.orderlist.serviceBtnList,
            () => {
                this._onViewableItemsChanged({viewableItems: this.viewableItems})
            }
        )

        if (props.useCache) {
            this.netInfoLintener = NetInfo.addEventListener(this.networkChangeHandler);
        }

        this.viewabilityConfig = {
            waitForInteraction: false,
            itemVisiblePercentThreshold: 100
        };

        this.props.orderlist.scrollToTop = this.scrollToTop;
        // this.props.store.orderlist.scrollToTop = this.scrollToTop
        // alert(this.props.store.orderlist.scrollToTop)
    }
    /* eslint-disable */
    // componentWillReceiveProps(nextProps) {
    //     // 切换业务线，切换状态栏、下拉刷新都叫init，他们的特点就是更新之后的订单大于0条但是小于10条
    //     // init都需要埋点，上拉加载更多不埋点
    //     if (
    //         nextProps.originDataSource !== this.props.originDataSource &&
    //         nextProps.originDataSource.length > 0 && (
    //             nextProps.originDataSource.length <= 10 ||
    //             nextProps.statusFilter === 'needComment'
    //         )
    //     ) {
    //         this.updateIsInit = true;
    //         $perfQav && $perfQav.setWillUpdate(Date.now());
    //     }
    // }

    static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (!prevState || nextProps.originDataSource !== prevState.originDataSource) {
            return nextProps;
        }
        return null;
    }

    componentDidUpdate(prevProps: Props) {
        // 如果是待点评和退款tab,因为是一次下发所有数据,所以只要有值就认定为一屏数据,其他会判断是否<=10,防止二屏数据拼接后继续当一屏数据使用
        if (
            !prevProps ||
            (this.props.originDataSource !== prevProps.originDataSource &&
                this.props.originDataSource.length > 0 &&
                (this.props.originDataSource.length <= 10 ||
                    this.props.statusFilter === 'needComment' || this.props.statusFilter === 'refund' ))
        ) {
            this.updateIsInit = true;
            this.props.perfQav?.setWillUpdate(Date.now());
        }

        if (this.updateIsInit) {
            const { setInLoading, needPerfQavLog } = this.props;
            if (needPerfQavLog && this.props.perfQav) {
                this.props.perfQav.setDidUpdate(Date.now());
                this.props.perfQav.send();
            }
            this.updateIsInit = false;
        }
    }
    /* eslint-enable */

    public componentWillUnmount() {
        // 解绑reaction
        this.stopInLoadingDispose();
        this.stopLoadMoreDispose();
        this.stopRefreshDispose();
        this.scrollTopAndRefreshDispose();
        this.datasourceDispose();
        this.asyncBtnListDispose();
        const { useCache } = this.props;
        if (useCache && this.netInfoLintener) {
            this.netInfoLintener();
        }
        // this.hideSwipeListener&&QSendNotification.removeNotification({
        //     name: kRNScreenshot_Notice_Name,
        //     subscription: this.hideSwipeListener,
        //     errorCallback: (res) => {}
        // })
    }

    public componentDidMount() {
        QSendNotification.addNotification({
            name: 'order-hide-swipe',
            subscriptionCallback:(subscription)=>{
                this.hideSwipeListener = subscription;
            },
            dataCallback: ()=>{
                this.closeSwipeFunc()
            },
        })
    }

    public closeSwipeFunc = () => {
        this.closeSwipe && this.closeSwipe();
        this.closeSwipe = null;
    }

    public setScrollY = (y: number) => {
        this.scrollY = DeviceInfo.isIOS ? y : y - REFRESH_HEIGHT_ADR;
    };

    public networkChangeHandler = (params: { type: string }) => {
        const { type } = params;
        const { toggleNetworkConnect } = this.props;
        if (type === 'none' || type === 'unknown') {
            toggleNetworkConnect(false);
        } else {
            toggleNetworkConnect(true);
        }
    };

    // 点击无数据蒙版中的去登录按钮
    public onPressLogin = async () => {
        const { onloginSuc, pageName } = this.props;
        qav({
            page: pageName,
            module: 'loginBtn',
            path: [{ title: '登录', position: '0' }],
            operType: 'click'
        });
        this.props.loginManager.isLogining = true
        const loginSuc = await loginUtil.login();
        loginSuc && onloginSuc && onloginSuc(loginSuc);
        // if (loginSuc) {
        //     onloginSuc && onloginSuc(loginSuc);
        // }
    };

    // 点击无数据蒙版中的重试按钮
    public onPressRedo = () => {
        const { init } = this.props;
        init();
    };

    public onScroll = (params: { nativeEvent: any }) => {
        if(DeviceInfo.isMini){
            return
        }
        const { nativeEvent } = params;
        const { toggleShowBackToTop } = this.props;
        const {
            contentOffset: { y }
        } = nativeEvent;
        this.setScrollY(y);
        this.closeSwipe && this.closeSwipe();
        this.closeSwipe = null;
        this.setState({showBackToTop:this.scrollY > 300})
        toggleShowBackToTop(this.scrollY > 300);
    };

    public getClose = (openedSwipe: any, closeSwipe: any) => {
        this.openedSwipe = openedSwipe;
        this.closeSwipe = closeSwipe;
    };

    public scrollToTop = (animated = true) => {
        if (!this.scrollViewRef) {
            return;
        }

        this.scrollViewRef.scrollToOffset({ offset: 0, animated });
    };

    public onRefresh = () => {
        const { init } = this.props;
        this.props.orderlist.privateOrderWord = '';
        this.setState({ refreshing: true });

        init('refresh');
    };

    public onLoad = () => {
        const { hasMore, loadMore } = this.props;
        const { loading } = this.state;
        if (!hasMore) {
            return;
        }
        if (!loading) {
            this.setState({ loading: true });
            loadMore();
        }
    };

    public onScrollEndDrag = (e: { nativeEvent: any }) => {
        const { contentOffset } = e.nativeEvent;
        if (this.refreshControl) {
            this.refreshControl.onRelease(
                {
                    y: -contentOffset.y
                },
                this.onRefresh
            );
        }
    };

    public renderListSingleCell = (item: any,index:any,dataType:any,mergeIndex:any) => {
        const { enableDelete, onOrderItemPress, onOrderBtnPress, onOrderDeletePress } = this.props;
        const ItemComp = getComponentByBusinessType(item.businessType);
        if (ItemComp) {
            const data = ItemComp.formatData({
                ...item,
                title: headerTitleByBusinessType(item.businessType),
                _disable: uitls.checkDisable(item.status)
            });
            item.actionInfos = data.actionInfos;

            const WrapperClazz: any = index > INITIAL_LOAD_NUM ? QSlugger : ItemWrapper;
            const ItemCompClazz = index > INITIAL_LOAD_NUM ? QSlugger: ItemComp;

            return (
                <WrapperClazz
                    target={ItemWrapper}
                    index={index}
                    key={item.orderNo}
                    dataType={dataType}
                    mergeIndex={mergeIndex}
                    orderCellIndex = {index}
                    sourceFrom={this.props.sourceFrom}
                    data={data}
                    enableDelete={enableDelete}
                    getClose={this.getClose}
                    onOrderDeletePress={onOrderDeletePress}
                    onOrderItemPress={onOrderItemPress}
                    onOrderBtnPress={onOrderBtnPress}
                    onBeginSwipe={(curSwipe: any) => {
                        if (curSwipe !== this.openedSwipe) {
                            this.closeSwipe && this.closeSwipe();
                            this.closeSwipe = null;
                        }
                    }}
                    onSwipeScroll={(scrollEnabled: boolean) => {
                        this.scrollViewRef &&
                        this.scrollViewRef._listRef &&
                        this.scrollViewRef._listRef.setNativeProps({ scrollEnabled });
                        // const listRef = this.scrollViewRef ? this.scrollViewRef.getListRef() : null;
                        // listRef && listRef.setNativeProps({
                        //         scrollEnabled
                        //     });
                    }}
                    onRefresh={this.onRefresh}
                >
                    <ItemCompClazz target={ItemComp} data={data} />
                </WrapperClazz>
            );
        }
        return <Text key={item.orderNo}>{item.businessType}</Text>;
    }

    public renderListCell = (params: { item: any,index:number}) => {
        const { item,index } = params;
        if(item.flightMerge){//组合单
            const dataList = item.listData || [];
            return (
                <View style={styles.orderMergeWrap} key={item.combinationId}>
                    <View style={styles.orderMergeView}>
                        {dataList.map((v:any,i:number) => this.renderListSingleCell(v,index*1000+i,'merge',i))}
                    </View>
                </View>
            )
        }else{
            return this.renderListSingleCell(item,index,'','');
        }
    };

    public renderLoadControl = () => {
        const {
            hasMore,
            loadmoreSuc,
            inLoading,
            originDataSource,
            showLoadMore,
            orderlist
        } = this.props;

        const { loading } = this.state;
        const { requestParams = {} } = orderlist;
        const isTrainList = requestParams.businessTypes === 'train';
        const trainTip = '没有更多了';

        return !inLoading && showLoadMore && originDataSource.length >= 10
            ? (
                <LoadControl
                    height={62}
                    isLoading={loading}
                    noMore={!hasMore}
                    noticeContent={loadmoreSuc ? '加载更多' : '加载失败，点击重试'}
                    loadingContent="加载中..."
                    noMoreContent='没有更多了'
                    style={styles.loadMoreContainer}
                    textStyle={styles.refreshControlText}
                    iconStyle={styles.refreshControlIcon}
                    onLoad={this.onLoad}
                    onPress={() => {
                        if (!loadmoreSuc) {
                            this.onLoad();
                        }
                    }}
                />
            )
            : isTrainList && !inLoading
                ? (
                    <View style={[styles.trainLimitTipView, { height: 62,paddingBottom:20 }]}>
                        <Text style={styles.trainLimitTipText}>
                            {trainTip}
                        </Text>
                    </View>
                )
                : (
                    <View style={{ height: isMini ? 50 : 12, backgroundColor: 'transparent',paddingBottom:20 }} />
                );
    }

    public _onViewableItemsChanged: (params: { viewableItems: any[] }) => void = ({viewableItems})=>{
        this.viewableItems = viewableItems;
        this.props.orderlist.changeShowingItems(viewableItems);
        if (viewableItems && viewableItems.length > 0) {
            // eslint-disable-next-line array-callback-return
            viewableItems.map((item) => {
                if (item?.item?.buttonListToShowLog && item.item.buttonListToShowLog.length) {
                    item.item.buttonListToShowLog.map((action:any, buttonIndex: number) => {

                        const asyncRes = this.props.serviceBtnList.find(butonListItem => {
                            return butonListItem && item.item && butonListItem.orderNo === item.item.orderNo;
                        })

                        if (asyncRes?.appAction?.length) {
                            let resAsyncAction = asyncRes.appAction.find((asyncAction: any)=>(asyncAction.actionName === action.actionName))
                            if (resAsyncAction && !resAsyncAction.hasShowed) {
                                resAsyncAction.hasShowed = true;
                                // 再判断一下是不是同步按钮中有相同的按钮,如果有相同的按钮,则不埋点
                                if (item?.item?.actionInfos && item.item.actionInfos.length){
                                    let findRes = item.item.actionInfos.find((itemAction: any) => (itemAction.actionName === action.actionName))
                                    if (findRes) {
                                        return undefined;
                                    }
                                }
                                PPLogUtil.orderButtonClickOrShowLog(action.title, OPER_SHOW, item.item.sysCode, item.item.orderNo, item.item.businessType, this.props.sourceFrom, (buttonIndex + 1).toString(), action);
                            }
                        }
                    });
                }

                if (!item.item.hasShowed){
                    let hasRedPoint = false;
                    item.item?.extData?.serviceProgress.forEach((i: any) => {
                        if (i.redPoint) {
                            hasRedPoint = true;
                        }
                    })
                    hasRedPoint && this.props.clearRedPoint(item.item?.sysCode, item.item?.orderNo);
                    item.item.hasShowed = true;
                    PPLogUtil.orderCardShowOrClickLog(OPER_SHOW, item.item.sysCode, item.item.orderNo, item.item.businessType, this.props.sourceFrom, (item.index + 1).toString());
                    if (item.item.private) {
                        PPLogUtil.privateOrderCardShowOrClick(false);
                    }

                    // 同步下发的按钮展示埋点
                    if (item.item.actionInfos && item.item.actionInfos.length){
                        // eslint-disable-next-line array-callback-return
                        item.item.actionInfos.map((action:any, buttonIndex: number) => {
                            PPLogUtil.orderButtonClickOrShowLog(action.title, OPER_SHOW, item.item.sysCode, item.item.orderNo, item.item.businessType, this.props.sourceFrom, (buttonIndex + 1).toString(), action);
                        });
                    }
    
                }

            });
        }
    }

    public render() {
        const {
            inLoading,
            alertVisible,
            alertTitle,
            cofirmVisible,
            privateVisible,
            dataSource,
            init,
            onAlertClose,
            onDeleteConfirmOk,
            onDeleteConfirmCancel,
            setInLoading,
            privateCofirmVisible,
            privateCofirmCallback,
            orderSearchFlag,
            orderPopup,
            orderPopupVisible,
            onCancelWxPopup
        } = this.props;
        const { refreshing,showBackToTop } = this.state;
        const privateOrderConfirm = (
            <View style={styles.privateCont}>
                <Text style={styles.privateContHint1}>请先关闭无痕预定，再选择客服功能。</Text>
                <Text style={styles.privateContHint2}>无痕状态下使用客服功能,相应的服务处理结果无法通知到您，请先关闭无痕预定，再选择客服功能。</Text>
            </View>
        )
        for(let i of dataSource) {
            if (i.showPrivilegeData && i.showPrivilegeData.todayFirstAccess) {
                i.showPrivilegeData.memberShouldAnimate = true;
               break;
            }
        }
        return (
            <View style={styles.orderListCompWrapper}>
                <FlatList
                    ref={(ref) => {
                        this.scrollViewRef = ref;
                    }}
                    // offsetY={0} 不存在该属性
                    refreshing={refreshing}
                    style={styles.orderListComp}
                    data={dataSource}
                    // 关联&&绑定微信提示
                    ListHeaderComponent={orderSearchFlag()?null:<GuideWeChat />}
                    onEndReachedThreshold={0.3}
                    scrollEventThrottle={16}
                    showsVerticalScrollIndicator={false}
                    onScroll={this.onScroll}
                    renderItem={this.renderListCell}
                    // onScrollEndDrag={this.onScrollEndDrag}
                    onEndReached={() => this.onLoad()}
                    onRefresh={DeviceInfo.isNotRn ? null : this.onRefresh}
                    ListFooterComponent={this.renderLoadControl()}
                    viewabilityConfig={this.viewabilityConfig}
                    onViewableItemsChanged={this._onViewableItemsChanged}
                    keyExtractor={(item, index) => item.orderNo}
                />
                {/* 返回顶部按钮 */}
                {showBackToTop && <QSlugger target={BackToTop} onPress={this.scrollToTop} showBackToTop={showBackToTop}/>}
                <QSlugger target={NoData} onPressLogin={this.onPressLogin} onPressRedo={this.onPressRedo} />
                {/** loading */}
                { !DeviceInfo.isMini && Boolean(inLoading) && <Spin loading={Boolean(inLoading)} onClose = {() => {
                    setInLoading(0)
                }} />}
                {
                    !DeviceInfo.isMini
                    && alertVisible
                    &&
                    <QSlugger
                        target={Alert}
                        isVisible={alertVisible}
                        onCancel={onAlertClose}
                        onOk={onAlertClose}
                        content={alertTitle}
                        btnText="知道了"
                    />
                }
                {
                    !DeviceInfo.isMini
                    && cofirmVisible
                    &&
                    <QSlugger
                        target={Confirm}
                        conStyle={{ width: 280 }}
                        isVisible={cofirmVisible}
                        onOk={onDeleteConfirmOk}
                        onCancel={onDeleteConfirmCancel}
                        title="删除订单后将无法还原"
                        content={<Text style={{fontSize:14, color:'#333333', lineHeight: 20}}>删除订单后将无法查看订单相关信息，或进行任何订单操作，确定<Text style={{color:'#F5200A'}}>完全删除</Text>此订单？</Text>}
                        cancelBtnText="点错了"
                        okBtnText="确认删除"
                        okBtnStyle={{color: '#F5200A'}}
                        cancelBtnOnRight={true}
                    />
                }
                {
                    !DeviceInfo.isMini
                    && privateVisible
                    &&
                    <QSlugger
                        target={Confirm}
                        conStyle={{ width: 280 }}
                        isVisible={privateVisible}
                        onOk={() => {
                            privateCofirmCallback();
                            privateCofirmVisible(false);
                        }}
                        onCancel={() => {
                            privateCofirmVisible(false);
                        }}
                        title="提示"
                        content={privateOrderConfirm}
                        cancelBtnText="取消"
                        okBtnText="去关闭"
                    />
                }
                {/* 微信公众号弹窗 */}
                {
                    !DeviceInfo.isMini
                    && orderPopupVisible
                    &&
                    <QSlugger 
                        target={OrderWxPopup}
                        isVisible={orderPopupVisible}
                        popData = {orderPopup}
                        onOk={(jumpUrl:string) => {
                            // jump
                            Ext.Router.Bridge.sendScheme({
                                url: `${DeviceInfo.scheme}${jumpUrl}`
                            }, () => null);
                            onCancelWxPopup(false);
                        }}
                        onCancel={() => {
                            onCancelWxPopup(false);
                        }}
                    />
                }
                {
                    DeviceInfo.releaseType === 'beta' && <DebugButton />
                }
            </View>
        );
    }
}
export default OrderListComp;
